<script>
import {
  formValidationProps,
  useFormValidation
} from "@/components/organisms/mixins/form-validation.mixin";
import Button from "@/components/atoms/button";
import Form from "@/components/molecules/form";
import FormSelect from "@/components/molecules/form-select";
import FormSelectOption from "@/components/molecules/form-select/form-select-option";
import Titre from "@/components/atoms/titre";
import StateOverlay from "@/components/molecules/state-overlay";
import { states } from "@/components/molecules/mixins/form.mixin";

export default {
  name: "MagasinSelector",
  components: {
    Form,
    Button,
    FormSelect,
    FormSelectOption,
    StateOverlay,
    Titre
  },
  props: {
    magasins: {
      type: Array,
      required: true
    },
    ...formValidationProps()
  },
  emits: ["selectMagasin"],
  setup(props) {
    const { v$, states, isLoadingComputed } = useFormValidation(props);
    return {
      v$,
      states,
      isLoadingComputed
    };
  },
  data() {
    return {
      idMagasin: null
    };
  },
  computed: {
    isLoading() {
      return this.state === states.LOADING;
    }
  },
  methods: {
    selectMagasin() {
      this.$emit("selectMagasin", this.idMagasin);
    }
  }
};
</script>

<template>
  <StateOverlay
    :is-loading="isLoadingComputed"
    overlay
  >
    <label for="magSelectorSelect">
      <Titre
        tag="h1"
        variant="primary"
        size="md"
        class="u-mb-md u-mt-sm u-ml-sm u-mr-sm u-text-center"
      >
        Choisissez un nouveau magasin de rattachement
      </Titre>
    </label>
    <Form
      :error="error"
      @submit.prevent="selectMagasin"
    >
      <div class="u-flex u-flex-justify-center u-mt-md">
        <FormSelect
          id="magSelectorSelect"
          v-model="idMagasin"
          default-value="Sélectionnez un magasin"
        >
          <FormSelectOption
            v-for="magasin in magasins"
            :key="magasin.id"
            :value="magasin.id"
          >
            {{ magasin.attributes.magasin }}
          </FormSelectOption>
        </FormSelect>
      </div>

      <div class="u-mr-lg u-ml-lg u-mt-lg u-mb-lg u-text-center">
        <Button
          variant="secondary"
          radius="full"
          size="md"
          :disabled="!idMagasin"
          type="submit"
          value="Je confirme ce magasin"
        />
      </div>
    </Form>
  </StateOverlay>
</template>

<style lang="scss" scoped>
</style>
